package com.flowyride.core.domain.geocoding

import com.flowyride.core.domain.model.GeoPoint
import com.flowyride.core.domain.model.Place

/** Turns free text into candidate places. */
interface Geocoder {
    /** @throws GeocodingException */
    suspend fun search(query: String, limit: Int): List<Place>

    /**
     * Names the place at [point] (e.g. a spot picked on the map). The returned place keeps [point]
     * as its position: the rider chose that exact spot, not the nearest known feature.
     *
     * @return null when nothing is known around [point].
     * @throws GeocodingException
     */
    suspend fun reverse(point: GeoPoint): Place?
}

class GeocodingException(message: String, cause: Throwable? = null) : Exception(message, cause)
